import React from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const SIZE_STYLES = {
  sm: { width: '1.25rem', height: '1.25rem', fontSize: '0.75rem' },
  md: { width: '1.5rem', height: '1.5rem', fontSize: '0.875rem' },
  lg: { width: '1.75rem', height: '1.75rem', fontSize: '1rem' },
};

const InfoComponent = ({ text, style = {}, size = 'md', placement = 'right', className = '' }) => {
  const mergedSize = SIZE_STYLES[size] || SIZE_STYLES.md;
  const mergedStyle = {
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    lineHeight: 1,
    color: '#fff',
    backgroundColor: '#6c757d',
    border: 'none',
    ...mergedSize,
    ...style,
  };

  const tooltip = (
    <Tooltip id="info-component-tooltip">
      {text}
    </Tooltip>
  );

  const buttonClassName = [
    'btn',
    'btn-secondary',
    'info-component-trigger',
    'd-inline-flex',
    'align-items-center',
    'justify-content-center',
    'rounded-circle',
    'p-0',
    className,
  ].filter(Boolean).join(' ');

  return (
    <OverlayTrigger placement={placement} delay={{ show: 250, hide: 400 }} overlay={tooltip}>
      <button type="button" className={buttonClassName} style={mergedStyle}>
        <span aria-hidden="true">?</span>
        <span className="visually-hidden">Informations</span>
      </button>
    </OverlayTrigger>
  );
};

export default InfoComponent;
